import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Loader2 } from 'lucide-react';

/**
 * Route accessible uniquement aux utilisateurs Premium (pas Basic).
 * Les utilisateurs Basic sont redirigés vers /pricing.
 */
export function PrivatePremiumOnlyRoute({ children }: { children: React.ReactNode }) {
  const { user, loading, isPremium, isBasic, isAdmin, isBetatesteur, onboardingCompleted } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin text-brand-primary" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" />;
  }

  if (onboardingCompleted === null) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin text-brand-primary" />
      </div>
    );
  }

  if (onboardingCompleted === false) {
    return <Navigate to="/onboarding" replace />;
  }

  // Pas premium du tout → pricing
  if (!isPremium) {
    return <Navigate to="/pricing" />;
  }

  // Admin et bêta-testeurs ont toujours accès
  if (isAdmin || isBetatesteur) {
    return <>{children}</>;
  }

  // Utilisateurs Basic → pas accès, rediriger vers pricing
  if (isBasic) {
    return <Navigate to="/pricing" />;
  }

  return <>{children}</>;
}
